import { render, staticRenderFns } from "./ApiPayments.vue?vue&type=template&id=0df1a1e9&scoped=true"
import script from "./ApiPayments.vue?vue&type=script&lang=js"
export * from "./ApiPayments.vue?vue&type=script&lang=js"
import style0 from "./ApiPayments.vue?vue&type=style&index=0&id=0df1a1e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df1a1e9",
  null
  
)

export default component.exports